import { UiElement } from '../../ui/UiElement.js';
import { roundNumber } from '../../utils/utils.js';
import { formatLatLng } from '../popup/formattingUtils.js';

export { CoordinateControl };

/**
 * Simple overlay that shows the currently hovered coordinates
 *
 * @author rhess <robin.hess@awi.de>
 * 
 * @memberof vef.map
 */
class CoordinateControl extends UiElement {

    constructor(map, position, layerTree) {
        super();

        this.map = map;
        this.position = position || "bottom-left";

        this.currentView_ = 0;
        this.lat_ = 0;
        this.lng_ = 0;

        // initialize element
        const element = this.getElement();
        element.classList.add("coordinate-control");
        element.addEventListener("click", () => this.switchView());

        this.map.on("mousemove", e => this.setCoordinates(e.lat, e.lng))
        this.map.addTool(this, this.position);
    }

    switchView() {
        this.currentView_ = (this.currentView_ + 1) % 3;
        this.displayCoordinates_();
    }

    displayCoordinates_() {
        let html = "";
        let coords = "";

        switch (this.currentView_) {
            case 0:
                const lat = roundNumber(this.lat_, 2, true);
                const lng = roundNumber(this.lng_, 2, true);
                html = `<span style="min-width: 92px;">Latitude: ${lat}°</span><span>Longitude: ${lng}°</span>`;
                break;
            case 1:
                coords = formatLatLng(this.lat_, this.lng_).split(", ");
                html = `<span style="min-width: 55px;">${coords[0]}</span><span>${coords[1]}</span>`;
                break;
            case 2:
                coords = formatLatLng(this.lat_, this.lng_, "degreeminutes").split(", ");
                html = `<span style="min-width: 77px;">${coords[0]}</span><span>${coords[1]}</span>`;
                break;
        }

        this.getElement().innerHTML = html;
    }

    setCoordinates(lat, lng) {
        this.lat_ = lat;
        this.lng_ = lng;
        this.displayCoordinates_();
    }
}